// systemGeometry.ts — Shared size math for a star system. systemExtent is the
// radius (scene units) that comfortably encloses the star, every planet's apoapsis,
// and any asteroid belt — the system's outer rim. CameraRig uses it for the zoom
// bounds; SystemDetail places the hyperlane singularities on it, so they ride the
// same rim the camera frames.
import type { StarSystem } from '../types';

export function systemExtent(system: StarSystem): number {
  let max = system.radius * 2;
  for (const p of system.planets) {
    max = Math.max(max, p.semiMajorAxis * (1 + p.eccentricity) + p.radius);
  }
  if (system.asteroidBelt) {
    max = Math.max(max, system.asteroidBelt.outerRadius);
  }
  return max * 1.15;
}
